module.exports = "/images/right-check.svg?ab3ed5d35482b8a12b83f7d2e3a6d93e";